<template>
  <div class="dashboard-infos__contacts infos-contacts">
    <div class="infos-contacts__header contacts-header">
      <h2 class="contacts-header__title">
        {{ trans('addresses.details.dashboard.contacts.title') }}
      </h2>
      <a class="contacts-header__link" :href="contactsLink">{{ trans('addresses.details.dashboard.contacts.link') }}</a>
    </div>
    <div class="infos-contacts__content">
      <address-contacts :address="address" :count-display="5" :wrap="true" />
    </div>
  </div>
</template>

<script>
import AddressContacts from '@components-molecules/AddressContacts.vue';
import { translationMixin } from '@elements/translation';
import { URL_ADDRESS_CONTACT_PAGE } from '@tools/routes/routes';

export default {
  components: { AddressContacts },
  mixins: [ translationMixin ],
  props: {
    address: { type: Object, required: true },
  },
  data() {
    return {
      contactsLink: URL_ADDRESS_CONTACT_PAGE.replace('{id}', this.address.id),
    };
  },
};
</script>
